import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboInstanceProxyCacheMetricsResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getInstanceProxyCacheMetrics;

const INSTANCE_PROXY_CACHE_METRICS_QUERY_KEY =
  'dbo-instance-proxy-cache-metrics';

const getInstanceProxyCacheMetricsQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => [INSTANCE_PROXY_CACHE_METRICS_QUERY_KEY, params] as const;

export const useInstanceProxyCacheMetricsQuery = <
  SELECT = DboInstanceProxyCacheMetricsResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboInstanceProxyCacheMetricsResponse, SELECT>
) =>
  useQuery(
    queryOptions({
      queryKey: getInstanceProxyCacheMetricsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      ...options,
    })
  );
